export const integrationsGetTechnologyPartnerData =
  "/integrations/get_technology_partner_data(/:pill)(/:app_group_id)";
